import RandomSlotView from "./randomSlotView";

export default function ScheduleView({ schedules }) {
  return (
    <div>
      <RandomSlotView schedule={schedules} />
    </div>
  );
}
